import React, { useEffect, useState } from "react"
import MapBox from "../MapBox/MapBox"
import { ACTIVE_VIEWS, DISTANCE } from "../../../shared_component/constants/checkout"
import ShopList from "./ShopList"
import { Modal } from "semantic-ui-react"
import FuelStationHeader from "./FuelStationHeader"
import { connect } from "react-redux"
import { getFuelStations } from "../../../v1/actions/fuelStation"
import { isEmpty } from "lodash"
import { USE_CURRENT_LOCATION } from "../../../v1/constants/mapbox"
import ShopSortingComponent from "../../../v1/CarAdvise2/screens/Map/components/ShopSortingComponent"
import { isMobile } from "react-device-detect"
import store from "../../../shared_component/utils/configureStore"
import Notifications from "../../../v1/components/Notifications"
import { useTranslation } from "react-i18next"

const SearchOnMap = ({ user, getFuelStations }) => {
  const { t } = useTranslation("fuelStation")

  const [activeTab, setActiveTab] = useState(ACTIVE_VIEWS.MAP)
  const [isLoading, setIsLoading] = useState(false)
  const [fuelStations, setFuelStations] = useState([])
  const [searchLocation, setSearchLocation] = useState({})
  const [sortingType, setSortingType] = useState("")
  const [isSortOpen, setIsSortOpen] = useState(false)
  const [open, setOpen] = useState(false)
  const [isSortOpenModal, setIsSortOpenModal] = useState(false)

  const expandCompressClick = () => {
    setIsSortOpen(false)
    setIsSortOpenModal(false)
    handleModel()
  }

  const hanldeModalSortingType = () => {
    setIsSortOpen(false)
    setIsSortOpenModal((prev) => !prev)
  }

  const handleModel = () => {
    setOpen((prev) => !prev)
  }

  const fetchFuelStation = async (apiQuery) => {
    setIsLoading(true)
    try {
      const apiPayload = isEmpty(apiQuery)
        ? {
            zip: user.zip ? user.zip : 60606
          }
        : apiQuery

      const res = await getFuelStations(apiPayload)

      if (res.error) {
        store.dispatch(
          Notifications.error({
            title: null,
            message: `${res.error}`,
            position: "tr",
            autoDismiss: 5,
            action: {
              label: "Dismiss"
            }
          })
        )
        return
      }

      setFuelStations(res?.result?.fuel_sites || [])
    } catch (error) {
      console.log("Error in fetchFuelStation", error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleSearchFuelStation = (suggest) => {
    setSearchLocation({
      lat: suggest?.location?.lat,
      lng: suggest?.location?.lng,
      isUserCurrentLocation: suggest?.name === USE_CURRENT_LOCATION
    })

    fetchFuelStation({
      lat: suggest?.location?.lat,
      lng: suggest?.location?.lng
    })
  }

  useEffect(() => {
    fetchFuelStation()
  }, [user.zip])

  const getFuelStationsDataWithSorting = () => {
    return sortingType == DISTANCE
      ? ([...fuelStations] || [])?.sort((a, b) => a.distance - b.distance)
      : fuelStations
  }

  return (
    <div className="search-shop-container">
      <div className="fuel-station-heading">
        <FuelStationHeader
          setIsSortOpen={setIsSortOpen}
          isSortOpen={isSortOpen}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          sortingType={sortingType}
          setSortingType={setSortingType}
          ignoreDisabled={true}
        />
      </div>

      {activeTab === ACTIVE_VIEWS.MAP && (
        <MapBox
          shops={fuelStations}
          isLoading={isLoading}
          expandCompressClick={expandCompressClick}
          onSuggestSelect={handleSearchFuelStation}
          searchLocation={searchLocation}
        />
      )}

      {activeTab === ACTIVE_VIEWS.LIST && (
        <div className="shop-list-container">
          <ShopList
            isLoading={isLoading}
            shops={getFuelStationsDataWithSorting()} // Sorting by distance in ascending order
          />
        </div>
      )}

      {open && (
        <Modal
          open={open}
          onClose={handleModel}
          onOpen={handleModel}
          className="fuel-station-modal"
        >
          <div className="modal-container">
            <div className="fuel-station-modal-header">
              <FuelStationHeader
                hideListAndMapOptions={true}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                sortingType={sortingType}
                setSortingType={setSortingType}
                setIsSortOpen={hanldeModalSortingType}
                isSortOpen={isSortOpenModal}
                ignoreDisabled={true}
              />
            </div>
            <div className="fuel-station-box">
              <div className="shop-list-section">
                <ShopList
                  isLoading={isLoading}
                  shops={getFuelStationsDataWithSorting()} // Sorting by distance in ascending order
                />
              </div>
              <div className="map-box-section">
                <MapBox
                  shops={fuelStations}
                  isLoading={isLoading}
                  isExpanded={open}
                  containerClassName="map-modal"
                  wantExpandCollapse={false}
                  expandCompressClick={expandCompressClick}
                  onSuggestSelect={handleSearchFuelStation}
                  searchLocation={searchLocation}
                />
              </div>
              {isMobile && (
                <div className="map-mobile-filter">
                  <ShopSortingComponent
                    setSortingType={(value) => setSortingType(value)}
                    sortingType={sortingType}
                    setIsSortOpen={hanldeModalSortingType}
                    isSortOpen={isSortOpenModal}
                    showPriceFilter={false}
                  />
                </div>
              )}
            </div>
          </div>
        </Modal>
      )}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.user
  }
}

export default connect(mapStateToProps, {
  getFuelStations
})(SearchOnMap)
